import { defineComponent as _defineComponent } from 'vue'
import KbFlowImage from '@/components/kb-image/kb-flow-image.vue'
import OpenApp from './open-app.vue'

import { useModal } from '@/hooks/use-modal'
import { watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'open-app-dialog',
  props: {
    extInfo: null
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    extInfo: { action?: string; actionParams?: any }
}





const modal = useModal({ visible: true })

watch(() => modal.visible, () => {
    if (!modal.visible) {
        emits('close')
    }
})

return { __sfc: true,props, emits, modal, KbFlowImage, OpenApp }
}

})